import {Injectable} from '@angular/core';
import {BaseEndpointService} from './base-endpoint-service';
import {ListItem} from "src/app/entities/list-item.entity";
import {Observable, take} from 'rxjs';
import {Backend, SingleResponse} from '@generated-backend-types';
import Statistics = Backend.App.Resources.Dashboard.Statistics.Statistics;
import StatisticsTimeframeData = Backend.App.Data.Dashboard.Statistics.StatisticsTimeframeData;

@Injectable({providedIn: 'root'})
export class StatisticsService extends BaseEndpointService<BaseResource, StatisticsTimeframeData> {
  protected override endpoint = '/statistics';

  public override modelToMultiSelectItem(m: BaseResource): ListItem & { model: BaseResource; } {
    throw new Error("Method not implemented." + m.id);
  }

  public getStats(timeFrameData: StatisticsTimeframeData): Observable<SingleResponse<Statistics>> {
    return this.http.post<SingleResponse<Statistics>>(this.endpoint, timeFrameData).pipe(take(1));
  }
}
